import { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useJobPositionsT } from './useJobPositions';

const FIELDS = [
  ['nameSr', 'nameSr'],
  ['nameEn', 'nameEn'],
  ['sectorName', 'sectorName'],
  ['headcount', 'headcount'],
  ['educationLevelRaw', 'educationLevel'],
  ['supervisorFunction', 'supervisorFunction'],
  ['abCode', 'abCode'],
];

/**
 * One row of the import preview, corrected before the import. Nothing is
 * written here: the change goes back to the preview, which checks it again.
 */
export default function JobPositionImportRowModal({ row, onClose, onSave }) {
  const { tj } = useJobPositionsT();
  const [form] = Form.useForm();

  useEffect(() => {
    if (row) form.setFieldsValue(row);
  }, [row, form]);

  return (
    <Modal
      open={!!row}
      onCancel={onClose}
      destroyOnHidden
      width={640}
      title={tj('importStatus.editTitle', { row: row?.row })}
      footer={
        <div className="flex justify-end gap-2">
          <Button className="!rounded-[50px]" onClick={onClose}>
            {tj('importStatus.cancel')}
          </Button>
          <Button
            type="primary"
            className="!rounded-[50px]"
            onClick={() => form.submit()}
          >
            {tj('importStatus.apply')}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" onFinish={onSave}>
        <div className="grid gap-x-4 sm:grid-cols-2">
          {FIELDS.map(([name, label]) => (
            <Form.Item key={name} name={name} label={tj(`field.${label}`)}>
              <Input />
            </Form.Item>
          ))}
        </div>
        <Form.Item name="description" label={tj('field.description')}>
          <Input.TextArea autoSize={{ minRows: 4, maxRows: 12 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
